import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import dayjs, { Dayjs } from "dayjs";

export const useSelectedDate = () => {
  const date = new URLSearchParams(useLocation().search).get("date");

  const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs());

  useEffect(() => {
    if (date) {
      setSelectedDate(dayjs(JSON.parse(date)));
    } else {
      setSelectedDate(dayjs());
    }
  }, [date]);

  return selectedDate;
};
